module.exports = __webpack_public_path__ + "img/gas.173441f9.svg";